import { useRpcCall } from "../core/useRpcCall.js";
export function useSession() {
  return {
    login: useRpcCall("oauthLogin"),
    register: useRpcCall("oauthRegister"),
    guestLogin: useRpcCall("oauthGuestLogin"),
    refreshToken: useRpcCall("refreshAccessToken"),
    revokeToken: useRpcCall("oauthRevokeToken"),
    forgetPassword: useRpcCall("oauthForgetPassword"),
    resetPasswordByHash: useRpcCall(
      "updatePasswordByHash"
    ),
    loginWithIDP: useRpcCall("handleIDPLoginCallback")
  };
}
